<template>
	<div>

		<b-navbar  type="dark" class="nav-pantone-blue" style="padding-top: 0!important">
			<div class="container">
				<b-navbar-brand href="/"><img src="@/assets/w_logo.png" id="logo"></b-navbar-brand>
				<b-navbar-toggle target="nav-collapse"/>
				<b-collapse id="nav-collapse" is-nav>
					<!--responsive menu - on screen minify -->
					<div class="menu-responsive d-lg-none d-md-block">
						<b-navbar-nav class="text-center">
							<b-nav-item @click="logout" class="profile align-items-center ">
							  <span class="font-weight-bold">
								<i class="fas fa-sign-in-alt"></i> Cerrar sesion
							  </span>
							</b-nav-item>
						</b-navbar-nav>
					</div>

					<b-navbar-nav class="ml-auto">
						<div class="menu-extends d-none d-lg-block">
							<!--on-login-->
							<div class="menu-section d-flex flex-row">
								<b-nav-item @click="logout" class="profile align-items-center ">
								  <span class="text-white typeAccount font-weight-bold">
									  <i class="fas fa-sign-in-alt"></i>
									  Cerrar sesion
								  </span>
								</b-nav-item>
							</div>
						</div>
					</b-navbar-nav>
				</b-collapse>
			</div>
		</b-navbar>

		<div class="container" v-if="showMessage != 0">

			<div class="p-5 text-center">
				<h1 class="font-blue mt-5">¡Listo!</h1>
				<p class="pt-3 h5">
					Tu información está siendo validada. <br>
					Mantente al pendiente, en un tiempo máximo de <b class="h5">48 hrs.</b> <br>
					recibirás un correo.<!-- en <b class="font-orange">{{signUpActivationEmail}}</b>.-->
					<br>
					<br>
					Recuerda revisar tu bandeja de correos no deseados para asegurarte <br>
					de que lo hayas recibido. <br>
					Una vez que lo recibas, activa tu cuenta ¡y accede!
				</p>
				<h2 class="font-blue pt-3">¡Gracias por completar la información!</h2>
			</div>

		</div>
		<div class="container" v-else>

			<div class="row justify-content-center">
				<div class="col-md-8 py-3 px-4 mt-5">

					<b-form @submit="onSubmit" v-if="!sendValidation">
						<h2 class="font-blue">Kllaar.com no pudo validar tu información.</h2>
						<p class="text-left">Requerimos que nos ayudes completando la información de los campos para poder continuar en Kllaar.com</p>
						<hr>

						<p class="text-left my-3">
							<b>Toma en cuenta el siguiente comentario de nuestro equipo: </b>
							{{ form.comment }}
						</p>



						<b-form-group v-if="vname == 1">
							<label>Nombre <b class="font-orange">*</b></label>
							<b-form-input class="shadow-sm" size="lg" v-model="form.name" type="text"  placeholder="Ingresa tu nombre ">
							</b-form-input>
							<b-form-invalid-feedback :state="false" v-if="errors.name">
								El campo nombre es requerido.
							</b-form-invalid-feedback>
						</b-form-group>

						<b-form-group v-if="venterprise == 1">
							<label>Nombre de la Empresa <b class="font-orange">*</b></label>
							<b-form-input class="shadow-sm" size="lg" v-model="form.enterprise" type="text"  placeholder="Ingresa el nombre de tu empresa">
							</b-form-input>
							<b-form-invalid-feedback :state="false" v-if="errors.enterprise">
								El campo nombre de la empresa es requerido.
							</b-form-invalid-feedback>
						</b-form-group>


						<b-form-group v-if="vgiro == 1">
							<label>GIRO <b class="font-orange">*</b></label>
							<vue-bootstrap-typeahead size="lg"
													 placeholder="Ej. Informática y Sistemas"
													 input-class="shadow-sm"
													 v-model="form.giro"
													 :data="workAreas"
							/>
							<b-form-invalid-feedback :state="false" v-if="errors.giro" class="font-weight-lighter">
								El campo giro es requerido.
							</b-form-invalid-feedback>
						</b-form-group>



						<b-form-group v-if="vlocation == 1">
							<label>Domicilio fiscal <b class="font-orange">*</b></label>
							<b-form-input class="shadow-sm" size="lg" v-model="form.location" type="text"  placeholder="Ingresa el nombre domicilio fiscal">
							</b-form-input>
							<b-form-invalid-feedback :state="false" v-if="errors.location">
								El campo domicilio fiscal es requerido.
							</b-form-invalid-feedback>
						</b-form-group>

						<b-form-group v-if="vtax_residence == 1">
							<label>Domicilio fiscal <b class="font-orange">*</b></label>
							<b-form-input class="shadow-sm" size="lg" v-model="form.tax_residence" type="text"  placeholder="Ingresa el nombre domicilio fiscal">
							</b-form-input>
							<b-form-invalid-feedback :state="false" v-if="errors.tax_residence">
								El campo domicilio fiscal es requerido.
							</b-form-invalid-feedback>
						</b-form-group>

						<b-form-group v-if="vrfc == 1">
							<label>RFC <b class="font-orange">*</b></label>
							<b-form-input class="shadow-sm" size="lg" v-model="form.rfc" type="text"  placeholder="RFC"></b-form-input>
							<b-form-invalid-feedback :state="false" v-if="errors.rfc">
								El campo rfc es requerido.
							</b-form-invalid-feedback>
						</b-form-group>

						<b-form-group v-if="vemail == 1">
							<label>Correo electrónico <b class="font-orange">*</b></label>
							<b-form-input class="shadow-sm" size="lg" v-model="form.email" type="email"  placeholder="Ingresa tu cuenta de correo">
							</b-form-input>
							<b-form-invalid-feedback :state="false" v-if="errors.email">
								El campo correo electrónico es requerido.
							</b-form-invalid-feedback>
						</b-form-group>


						<b-form-group v-if="vwebsite == 1">
							<label>Sitio Web <b class="font-orange">*</b></label>
							<b-form-input class="shadow-sm" size="lg" type="text" v-model="form.website" placeholder="https://"></b-form-input>
							<b-form-invalid-feedback :state="false" v-if="errors.website">
								El campo sitio web es requerido.
							</b-form-invalid-feedback>
						</b-form-group>



						<div class="__fileattach" v-if="vfiletrainer == 1">
							<div class="p-3 rounded mb-2">
								<h4 class="alert-heading font-blue">Carga de documento. <b class="font-orange">*</b></h4>
								<p>
									Requerimos que, por favor envíes la documentación que te acredite a
									ti.
									Recibirás nuestra respuesta vía correo electrónico en cuanto hayamos verificado tu información.
								</p>
								<label class="btn b-white bh-cursor" v-b-tooltip.hover title="Seleccionar un archivo de tu computadora">
									<i class="fas fa-check"     v-show="form.filetrainer"></i>
									<i class="fas fa-paperclip" v-show="!form.filetrainer"></i>
									<span v-show="!form.filetrainer">Seleccionar Documento</span>
									<span v-show="form.filetrainer">{{fileName}}</span>
									<input type="file" hidden ref="file" @change="handleFileUpload">
								</label>
								<p class="text-danger" v-show="errors.filetrainer">Asegurate de cargar un archivo</p>
							</div>

						</div>

						<div class="__fileattach" v-if="vfilerfc == 1">
							<div class="p-3 rounded mb-2">
								<h4 class="alert-heading font-blue">Carga de documento. <b class="font-orange">*</b></h4>
								<p>
									Requerimos que, por favor envíes la documentación que acredite tu empresa.
									Recibirás nuestra respuesta vía correo electrónico en cuanto hayamos verificado tu información.
								</p>
								<label class="btn b-white bh-cursor" v-b-tooltip.hover title="Seleccionar un archivo de tu computadora">
									<i class="fas fa-check"     v-show="form.filerfc"></i>
									<i class="fas fa-paperclip" v-show="!form.filerfc"></i>
									<span v-show="!form.filerfc">Seleccionar Documento</span>
									<span v-show="form.filerfc">{{fileNameRFC}}</span>
									<input type="file" hidden ref="file" @change="handleFileUploadRFC">
								</label>
								<p class="text-danger" v-show="errors.filerfc">Asegurate de cargar un archivo</p>
							</div>

						</div>

						<b-button type="submit" class="b-orange btn-lg shadow-sm mt-2 col-sm-12" :disabled="loading">
							Enviar
							<b-spinner v-if="loading" small label="Espere ..."></b-spinner>
						</b-button>


					</b-form>

				</div>
			</div>

		</div>





	</div>
</template>
<script>
export default {
	name: 'ValidateInformation',
	data() {
		return {

			loading: false,
			resendCode: false,
			email: '',
			response:[],
			fileName: '',
			fileNameRFC: '',
			sendValidation: false,
			workAreas:[],
			errors:{
				giro:false
			},
			form:{
				id:'',
				type:'',
				id_validate:'',
				comment: '',
				name: '',
				enterprise: '',
				rfc: '',
				email: '',
				website: '',
				location:'',
				giro:'',

				tax_residence:'',
				filerfc:'',

				filetrainer:''
			},
			vcomment:false,
			vtax_residence:false,
			vfilerfc:false,
			vname:false,
			venterprise:false,
			vrfc:false,
			vemail:false,
			vwebsite:false,
			vfiletrainer:false,
			vlocation:false,
			vgiro:false,
			showMessage:false,
		}
	},
	created() {
		this.validateInformation()
	},
	watch: {
		form: {
			deep: true,
			handler() {

				if (this.form.giro && this.form.giro.length > 1) {
					this.api.get('module/workarea/' + this.form.giro).then(({data}) => {
						this.workAreas = data.data
					}).catch(err => {
						console.log('error filtro')
					})
				}

			}

		},
	},
	methods:{
		handleFileUploadRFC(e){
			this.form.filerfc = e.target.files[0]
			this.fileNameRFC = e.target.files[0].name
		},
		handleFileUpload(e) {
			this.form.filetrainer = e.target.files[0]
			this.fileName = e.target.files[0].name
		},
		logout() {
			this.$store.dispatch('logout')
				.then(() => {
					location.reload()
				})
		},
		onSubmit(event){
			event.preventDefault()
			this.loading= true

			let vl = new FormData()
			vl.append('id', this.form.id)
			vl.append('type', this.form.type)
			vl.append('id_validate', this.form.id_validate)
			vl.append('comment', this.form.comment)
			vl.append('name', this.form.name)
			vl.append('enterprise', this.form.enterprise)
			vl.append('rfc', this.form.rfc)
			vl.append('email', this.form.email)
			vl.append('website', this.form.website)
			vl.append('location', this.form.location)
			vl.append('giro', this.form.giro)

			vl.append('tax_residence', this.form.tax_residence)
			vl.append('filerfc', this.form.filerfc)
			vl.append('filetrainer', this.form.filetrainer)


			this.api.post('auth/validate-user',vl).then(({data}) => {
				// location.reload()
				this.showMessage = true
			}).catch(err => {
				this.loading = false
				if(err.response.status === 422){
					this.errors = err.response.data.errors
				}
			})
		},

		validateInformation(){
			this.api.get('profile/validate-information').then(({data}) => {

				if(data.request){

					this.form.id         = data.data.user_id
					this.form.type        = data.data.type
					this.form.id_validate = data.data.id

					this.venterprise  = data.data.enterprise
					this.vgiro =data.data.giro
					this.vtax_residence = data.data.tax_residence
					this.vname = data.data.name
					this.vfiletrainer = data.data.filetrainer
					this.form.comment = data.data.comment
					this.vfilerfc = data.data.filerfc
					this.vemail = data.data.email
					this.vrfc = data.data.rfc
					this.vwebsite = data.data.website
					this.vlocation = data.data.location
					this.showMessage = data.data.show_message

				}
			}).catch(err => {
				console.log('profile validate information')
			})
		},
		toast(message){
			this.$bvToast.toast(message, {
				title: "Kllaar.com",
				variant: 'success',
				toaster: 'b-toaster-bottom-right',
				solid: true,
				appendToast: true
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/#pages/#auth/activation/ValidateInformation.vue